import { Container } from "pixi.js";
import { AbstractDisplayComponent } from "../../core/displays/AbstractDisplayComponent";
import { Character } from "./Character";

export class CharacterComponent extends AbstractDisplayComponent {
    private container: Character;

    public override init() {
        let config = {
            labelName: "characterComponent",
            anchorX: 0.5,
            anchorY: 0.5,
            landscape: {
                posX: 2158,
                posY: 1576,
                scale: 1,
            },
            portrait: {
                posX: 1825,
                posY: 2158,
                scale: 1,
            }
        };

        super.init();
        this.container = new Character(config);
    }



    public getInstance(): Container {

        return this.container;

    }



    public override destroy(): void {

        this.container.destroy({ children: true });

    }



    public animateCharacter(variant?: string): void {

        this.container.animateCharacter(variant);

    }

}

